<div class="tt-c-answer" :class="{'tt-c-answer--best' : isBestAnswer}">
  <div v-if="!isBestAnswer" class="tt-c-answer__votes">
    <tt-button type="icon" class="tt-c-answer__upvote" @click.prevent="vote" :disabled="!canVote" :aria-label="$msg('answer.voteUp')" :aria-pressed="wasVotedOn.toString()">
      <tt-icon :name="voteIconName" size="sm"></tt-icon>
    </tt-button>
  </div>
  <div class="tt-c-answer__body tt-u-spacing--xs">
    <p class="tt-c-answer__text"><span v-if="isBestAnswer" class="tt-c-answer__best-answer-label" v-html="$msg('answer.bestAnswer')"></span> <span class="tt-c-answer__best-answer-text" v-html="answer.text"></span></p>
    <tt-byline ref="byline" class="tt-c-answer__byline" :item="answer" ugcType="sa" :menuItems="menuItems" @menuItemSelected="menuItemSelected"></tt-byline>
    <div v-if="answer.multiItems.length > 0" class="tt-c-answer__multi-items">
      <tt-product-about v-for="multiItem in answer.multiItems" :catItem="multiItem" :showAbout="false"></tt-product-about>
    </div>
    <tt-reply-form v-if="showReplyForm"
                   :id="controlsId"
                   :answerId="answer.id"
                   :originSiteKey="originSiteKey"
                   parentType="answer"
                   :parent="answer"
                   :questionId="questionId"
                   :submissionCtx="submissionCtx"
                   @close="closeForm"></tt-reply-form>
    <div class="tt-c-answer__reply-list">
      <tt-reply v-for="reply in nestedReplies"
                :answerId="answer.id"
                :openReplyForReplyId="openReplyForReplyId"
                :originSiteKey="originSiteKey"
                :reply="reply"
                :questionId="questionId"
                :submissionCtx="submissionCtx"
                :key="reply.id"></tt-reply>
    </div>
    <div v-if="showActions" class="tt-c-answer__actions">
      <tt-button v-if="!showAllReplies" type="toolbar" class="tt-c-answer__actions-view-all" @click="showAllReplies = true" aria-expanded="false"><tt-icon name="options-expand" size="sm"></tt-icon><span class="tt-o-expander__text" v-html="$msg('answer.showAllReplies', [answer.replies.length])"></span></tt-button>
      <tt-button v-if="showAllReplies" type="toolbar" class="tt-c-answer__actions-hide-replies" @click="showAllReplies = false" aria-expanded="true"><tt-icon name="options-collapse" size="sm"></tt-icon><span class="tt-o-expander__text" v-html="$msg('answer.hideAllReplies')"></span></tt-button>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/components/answers/answer.html